import React from "react";
import "./AvatarUpload.styles.scss";
import { Avatar } from "../../Avatar/Avatar";
import FileBase64 from "react-file-base64";

interface AvatarUploadProps {
  onChange?: Function;
  className?: string;
  size?: number;
  label?: string;
  labelClassName?: string;
  avatarUrl?: string;
}

export const AvatarUpload: React.FC<AvatarUploadProps> = ({
  onChange = () => {},
  className = "",
  size = 40,
  label = "",
  labelClassName,
  avatarUrl,
}) => {
  return (
    <label className={`upload-avatar scale-click flex-col-fc-fc ${className}`}>
      <Avatar src={avatarUrl} className={className} size={size} />
      <FileBase64
        onDone={(data: any) => {
          onChange(data);
        }}
      />
      {/* <input hidden={true} onChange={e => {
          onChange(e)
          setFile(e.target.value)
        }}
      id='avatar-upload' type='file' className='upload-avatar__input'/> */}
      {label ? (
        <span className={`upload-avatar__label ${labelClassName}`}>
          {label}
        </span>
      ) : null}
    </label>
  );
};
